import { createSlice } from "@reduxjs/toolkit";

export const PointsReducer = createSlice({
  name: "pointsReducer",
  initialState: {
    fanduPoints: 0,
  },
  reducers: {
    setFanduPoints: (state, action) => {
      state.fanduPoints = action.payload;
    },
    addFanduPoints: (state, action) => {
      state.fanduPoints += action.payload;
    },
  },
});

export const { setFanduPoints, addFanduPoints } = PointsReducer.actions;

export default PointsReducer.reducer;
